import { render, staticRenderFns } from "./ProductsDraft.vue?vue&type=template&id=576fd8e6&scoped=true"
import script from "./ProductsDraft.vue?vue&type=script&lang=js"
export * from "./ProductsDraft.vue?vue&type=script&lang=js"
import style0 from "./ProductsDraft.vue?vue&type=style&index=0&id=576fd8e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576fd8e6",
  null
  
)

export default component.exports